import React, { useCallback, useMemo } from 'react';

import CheckDarkIcon from 'assets/pics/check-dark.png';
import CheckLightIcon from 'assets/pics/check-light.png';
import Proptypes from 'prop-types';

import './CustomCheckbox.sass';

export const CustomCheckbox = ({
  disabled,
  isEdited,
  name,
  error,
  id,
  value,
  onChange,
  testId,
}) => {
  const onChangeClick = useCallback(() => {
    if (disabled) return;

    const syntheticEvent = {
      target: {
        name,
        value: !value,
      },
    };
    onChange(syntheticEvent);
  }, [name, value, onChange]);

  const getClassnameForState = useMemo(() => {
    if (disabled) return 'disabled';
    if (isEdited) return 'edited';
    if (error) return 'error';
    return '';
  }, [disabled, isEdited, error]);

  const getClassnameForSelected = useMemo(() => {
    if (value === true) return 'selected';
    return '';
  }, [value]);
  const getAriaLabel = () => {
    if (disabled) return `${name} auswahlkästchen deaktiviert`;
    if (value) return `${name} auswahlkästchen ausgewählt`;
    return `${name} auswahlkästchen auswählen`;
  };
  return (
    <div className="custom-checkbox">
      <button
        data-testid={testId}
        aria-label={getAriaLabel}
        className={`custom-checkbox__input ${getClassnameForState} ${getClassnameForSelected}`}
        id={id}
        type="button"
        onClick={onChangeClick}>
        <img
          src={isEdited && !disabled ? CheckDarkIcon : CheckLightIcon}
          alt="checkbox"
          className={`custom-checkbox__check-icon ${getClassnameForSelected}`}
        />
      </button>
    </div>
  );
};

CustomCheckbox.propTypes = {
  disabled: Proptypes.bool,
  isEdited: Proptypes.bool,
  error: Proptypes.bool,
  name: Proptypes.string.isRequired,
  id: Proptypes.string.isRequired,
  value: Proptypes.bool.isRequired,
  onChange: Proptypes.func.isRequired,
  testId: Proptypes.string,
};

CustomCheckbox.defaultProps = {
  disabled: false,
  isEdited: false,
  error: false,
  testId: '',
};
